import {useMemo} from 'react';

/**
 * Hook to get the media slider key, taking into account the feature flag
 * @param configuredKey - The mediaSliderKey value from the config
 * @returns The effective mediaSliderKey to use
 */
export function useMediaSliderKey(configuredKey?: string): string {
  return useMemo(() => {
    return configuredKey ?? '_step';
  }, [configuredKey]);
}
